/**
 * MSW Overrides: Add Addons scenario
 *
 * Returns the real subscription response but with `plan.addons` replaced by
 * MOCK_ADDONS, allowing the add-addons UI flow to be tested end-to-end in
 * local development.
 *
 * Enable by setting ENABLE_MSW=true and NUXT_PUBLIC_MSW_OVERRIDES_ADD_ADDONS=true
 * in your .env, then restart the dev server.
 */

import type { HttpHandler } from 'msw';
import { http, HttpResponse } from 'msw';
import { BFF_ENDPOINTS, toMSWPattern } from '@cvo/domain';
import type { SubscriptionAddon } from '@cvo/domain';

export const MOCK_ADDONS: SubscriptionAddon[] = [
  {
    code: 'VEL-UNDERSEATBAG-INCLUDED-MONTHLY-PLAN',
    product: {
      code: 'VEL-UNDERSEATBAG-INCLUDED-MONTHLY',
      ancillary: 'UNDERSEATBAG',
    },
  },
  {
    code: 'VEL-CABINBAG-INCLUDED-MONTHLY-PLAN',
    product: {
      code: 'VEL-CABINBAG-INCLUDED-MONTHLY',
      ancillary: 'CABINBAG',
    },
  },
];

export function createAddAddonsOverrides(baseUrl: string): HttpHandler[] {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.get(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.SUBSCRIPTION)}`,
      async ({ request }) => {
        const originalResponse = await fetch(request);
        const data = await originalResponse.json();

        return HttpResponse.json({
          ...data,
          plan: {
            ...data.plan,
            addons: MOCK_ADDONS,
          },
        });
      },
    ),
  ];
}
